module.exports = __webpack_public_path__ + "images/a48e47b3e7c467aa63b551cc4a6a4bea221252f3790d21e6ec503996e755a16f.svg";